import React, { useEffect, useReducer, useRef } from 'react';
import { Chart, Series, Tooltip } from 'devextreme-react/chart';
import DataGrid, { Column, Lookup, Editing, Paging, Pager, ColumnFixing } from 'devextreme-react/data-grid';
import * as actions from '../../../actions/dashboard';
import dashboardReducer from '../../../reducers/dashboard';
import { GRID_CONFIG, COL_DEF, CHART_CONFIG } from './config'
import { Button } from 'devextreme-react/autocomplete';
import moment from 'moment';
import { set, get, setGridUserPrefs, setGridWidthPrefs, applyUserPref, saveUserPref } from "../../../common/utils";

const initialState = { downTimeData: null, reasonCodes: null, userPref: null }



const tooltipTpl = (info) => {

    return (
        <div className="state-tooltip">

            <div className="capital">
                <span className="caption">{info.argumentText}</span>
            </div>
            <div className="population">
                <span className="caption">Actual</span>: {info.point.data.actual}
            </div>
            <div>
                <span className="caption">Cumulative</span>: <span className="area-km">{info.point.data.cumulative}</span>
            </div>
        </div>
    );
}

export default ({ siteId, tierId, isEditable, widgetId }) => {
    const [state, dispatch] = useReducer(dashboardReducer, initialState);
    const { downTimeData, reasonCodes, userPref } = state;
    const downTimeGrd = useRef(null);
    const GRID_COLS = JSON.stringify(["id", "metricDate", "reasonCode", "plan", "actual"]);
    const loggedinUser = get("hid");
    const PREF_KEY = 'userPref_' + widgetId
    useEffect(() => {
        actions.fetchReasonCodes(dispatch, `siteId=${siteId}&tierId=${tierId}`)
        actions.fetchDowntimeData(dispatch, tierId);
    }, []);

    useEffect(() => {
        actions.fetchUserPref(
            dispatch,
            `=${tierId}&SiteUID=${siteId}&widgetID=${widgetId}`
        );
        return () => {
            actions.updateUserPref(dispatch, saveUserPref({ widgetId, siteId, tierId, moduleName: 'DownTimeReason', loggedinUser, prefSess: PREF_KEY, GRID_COLS }));
        };
    }, []);

    useEffect(() => {
        if (userPref) set(PREF_KEY, userPref);
        if (downTimeGrd && downTimeGrd.current && downTimeGrd.current.instance !== null && userPref && downTimeData) {
            applyUserPref(downTimeGrd, userPref)
        }

    }, [userPref, downTimeData, reasonCodes])

    const onRowUpdated = (data) => {
        let { id, tierID, metricDate, reasonCode, plan, actual, metricID } = data.data;
        let updateMetric = {
            "Id": parseInt(id),
            "TierId": parseInt(tierID),
            "MetricId": parseInt(metricID),
            "MetricDate": moment(metricDate).format(),
            "ReasonCode": reasonCode,
            "Plan": parseFloat(plan),
            "Actual": parseFloat(actual)
        }

        actions.updateDowntimeMetric(dispatch, updateMetric, tierId);
    }

    const onRowInserted = (data) => {
        let { metricDate, reasonCode, plan, actual, metricID } = data.data;
        let newMetric = {
            "TierId": parseInt(tierId),
            "MetricId": 1,
            "MetricDate": moment(metricDate).format(),
            "ReasonCode": reasonCode,
            "Plan": parseFloat(plan),
            "Actual": parseFloat(actual)
        }
        actions.addDowntimeMetric(dispatch, newMetric, tierId)
    }


    const onRowRemoved = (data) => {
        actions.deleteDowntimeMetric(dispatch, data.data.id, tierId)
    }
    const getChartData = () => {
        let downTimeTableData = downTimeData
        let downtimeChartData = [];

        downTimeTableData.reduce(function (res, value) {
            if (!res[value.reasonCode]) {
                res[value.reasonCode] = { reasonCode: value.reasonCode, actual: parseInt(value.actual) };
                downtimeChartData.push(res[value.reasonCode])
            } else
                res[value.reasonCode].actual = res[value.reasonCode].actual + parseInt(value.actual);
            return res;
        }, {});


        let data = downtimeChartData.sort(function (a, b) {
            return b.actual - a.actual;
        });

        let totalCount = data.reduce(function (prevValue, item) {
            return prevValue + item.actual;
        }, 0);

        let cumulativeCount = 0;

        let dataSource = data.map(function (item, index) {
            cumulativeCount += item.actual;
            return {
                reasonCode: item.reasonCode,
                actual: item.actual,
                cumulative: Math.round(cumulativeCount * 100 / totalCount)
            };
        });

        return dataSource;

    }
    let dRConfig = { ...GRID_CONFIG }


    if (!isEditable) {
        dRConfig.editing.allowUpdating = false
        dRConfig.editing.allowAdding = false
        dRConfig.editing.allowDeleting = false
    } else {
        dRConfig.editing.allowUpdating = true
        dRConfig.editing.allowAdding = true
        dRConfig.editing.allowDeleting = true
    }

    const handlers = {
        onRowUpdated: onRowUpdated,
        onRowRemoved: onRowRemoved,
        onRowInserted: onRowInserted
    }

    let column_def = COL_DEF;
    column_def[2]['lookup']['dataSource'] = reasonCodes;

    return (
        <div className="downtime-flex">
            <div className="downtime-chart">
                {downTimeData &&

                    <Chart id="chart" dataSource={getChartData()} {...CHART_CONFIG} >
                        <Tooltip
                            enabled={true}
                            shared={true}
                            contentRender={tooltipTpl}
                            opacity="5"
                            zIndex="101"

                        />
                    </Chart>

                }
            </div>
            <div className="downtime-chart">

                {reasonCodes &&
                    <DataGrid
                        dataSource={downTimeData}
                        onCellPrepared={function (e) {
                            if (e.rowType === "filter" && (e.column.dataField === "metricDate") && (e.column.dataField === "reasonCode"))
                                e.cellElement.firstChild.firstChild.style.display = "none"
                        }}
                        {...handlers}
                        {...dRConfig}
                        defaultColumns={column_def}
                        ref={downTimeGrd}
                        onContentReady={e => setGridUserPrefs(e, widgetId)}
                        onColumnsChanging={e => setGridWidthPrefs(e, widgetId)}
                        width="100%"
                    >
                        <ColumnFixing enabled={true} />
                        <Column fixedPosition="right" fixed={true} type="buttons" id="popup">

                            <Button name="delete"></Button>
                        </Column>
                    </DataGrid>


                }
            </div>

        </div>
    )

}



